export default {
  singleLabel: "Ligne de barème",
  storeNamespace: 'transport_rate',
  authFeature: 'transport-rate',
  listRouteName: "TransportRateList",
  newRouteName: "TransportRateNew",
  editRouteName: "TransportRateEdit",
  useNewModal: true,
  useEditModal: true,
  // La grille messagerie est un barème fermé (zones × paliers fournis par le client) :
  // on modifie les tarifs existants, on n'en crée pas de nouveaux à la volée.
  hideActionNewButton: true,
  formComponentName: 'TransportRateForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'zone_km_max',
  sortBy: 'zone_km_max',
  sortable: false,
  fields: [{
      name: 'zone_km_max',
      label: "Zone (km max)",
      type: 'number',
      step: '1',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
    },
    {
      name: 'weight_max',
      label: "Poids max (kg)",
      type: 'number',
      step: '0.1',
      inForm: true,
      required: true,
      inList: true,
      filterIn: true,
    },
    {
      name: 'price',
      label: "Prix A/R (€)",
      type: 'number',
      step: '0.01',
      inForm: true,
      required: true,
      inList: true,
      filterIn: false,
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/TransportRate/config.js